module.exports = __webpack_public_path__ + "img/31.9eab095c.png";